module.exports = __webpack_public_path__ + "bd7788c77a82efa6b675da2f44bc6f2a.jpeg";